<template>
  <div
    class="tw-w-full"
    :class="dense ? 'tw-p-0 tw-m-0' : ''">
    <label
      class="tw-w-full whitespace-normal tw-items-center"
      :class="[
        $props.labelAlignment === 'vertical' ? 'tw-grid-cols-4 tw-grid tw-rows-2' : 'tw-grid-cols-2 tw-grid sm:tw-grid-cols-4 tw-gap-3',
        dense ? 'tw-py-0 tw-my-0 tw-gap-1' : '',
      ]"
      :for="inputId">
      <div
        :class="`tw-p-2 tw-break-words tw-text-wrap tw-mx-auto tw-font-semibold tw-text-base md:tw-text-lg tw-flex tw-flex-col tw-items-start md:tw-items-end tw-justify-center md:tw-justify-center ${
          $props.labelAlignment === 'vertical' ? 'tw-col-span-1' : ''
        }`"
        v-if="label">
        <div class="tw-flex tw-flex-row">
          <div class="tw-flex tw-flex-col">
              <div class="tw-flex tw-items-center tw-gap-1">
                <span>{{ label }}</span>
                <span
                  v-if="required"
                  class="tw-text-status-red">
                  *
                </span>
              </div>
            <span
              v-if="additionalData"
              class="tw-text-xs md:tw-text-sm tw-font-light">
              {{ additionalData }}
            </span>
          </div>
          <div
            v-if="infoButtonText"
            class="tw-px-2">
            <Tooltip :text="infoButtonText">
              <font-awesome-icon
                icon="circle-info"
                class="tw-text-primary-600 tw-cursor-pointer" />
            </Tooltip>
          </div>
        </div>
      </div>

      <div
        :class="`tw-w-full ${label ? (secondaryLabel ? 'tw-col-span-1' : 'tw-col-span-3') : 'tw-col-span-4'}
        ${$props.labelAlignment === 'vertical' ? 'tw-row-start-2 tw-col-span-full' : ''}
        `">
        <slot></slot>
      </div>
      <div
        :class="`tw-col-start-auto tw-col-span-2 tw-whitespace-normal ${$props.labelAlignment === 'vertical' ? 'tw-col-start-4' : ''}`"
        :for="inputId"
        v-if="secondaryLabel">
        {{ secondaryLabel }}
      </div>
    </label>
  </div>
</template>
<script setup lang="ts">
import { PropType } from "vue";
import { BaseLabelPropsInterface } from "../BaseLabel/BaseLabelUtils";
import Tooltip from "../Tooltip/Tooltip.vue";

defineProps({
  inputId: {
    type: String as PropType<BaseLabelPropsInterface["inputId"]>,
    required: false,
  },
  label: {
    type: String as PropType<BaseLabelPropsInterface["label"]>,
    required: true,
  },
  labelAlignment: {
    type: String as PropType<BaseLabelPropsInterface["labelAlignment"]>,
    required: false,
    default: "horizontal",
  },
  additionalData: {
    type: String,
    required: false,
  },
  secondaryLabel: {
    type: String,
    required: false,
  },
  infoButtonText: {
    type: String,
  },
  required: {
    type: Boolean,
    default: false,
  },
  dense: {
    type: Boolean,
    default: false,
  },
});
</script>
